module.exports = __webpack_public_path__ + "images/leaseabike4e60e6099b84ae493a4ecf84a38cb073.png";